import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { IonNav, ModalController, ViewWillEnter } from '@ionic/angular';
import {
  isFilterCustomerData,
  ModalFilterCustomerData,
} from '../model/modal-filter';
import { UsfFilteringModalComponent } from '../usf-filtering-modal.component';

@Component({
  selector: 'app-usf-filtering-modal-mobile',
  templateUrl: './usf-filtering-modal-mobile.component.html',
  styleUrls: ['./usf-filtering-modal-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsfFilteringModalMobileComponent
  extends UsfFilteringModalComponent
  implements ViewWillEnter
{
  constructor(
    private nav: IonNav,
    modalController: ModalController,
    private cdr: ChangeDetectorRef,
  ) {
    super(modalController);
  }

  ionViewWillEnter(): void {
    this.updateCountsAndSubtitles();
    this.cdr.detectChanges();
  }

  selectFilter(index: number) {
    if (index !== undefined && index !== null) {
      const filter = this.filters[index];
      if (!!filter && !!filter.component) {
        if (isFilterCustomerData(filter.data)) {
          const customerData = filter.data as ModalFilterCustomerData;
          customerData.searchText$.next(''); //Force reset customer search filter
          this.nav.push(filter.component, {
            show: customerData.show,
            vm$: customerData.vm$,
            searchText$: customerData.searchText$,
            isPresentedInFilterModal: customerData.isPresentedInFilterModal,
            selectedCustomers: customerData.selectedCustomers,
            isTouch: this.isTouch,
          });
        } else {
          this.nav.push(filter.component, {
            data: filter.data,
            isTouch: this.isTouch,
          });
        }
      }
    }
  }

  openSortOptions() {
    this.nav.push(this.sortComponent.component, {
      data: this.sortComponent.data,
    });
  }
}
